import { del, get, patch, post, postForm, put, putForm, apiWrapper } from "../Utilities/Requests";
import * as url from "../Utilities/Request-Endpoints"

const formDataConfiguration = { headers: { 'content-type': 'multipart/form-data' } };
// export const updatePassword = (data) => apiWrapper(post,url.UPDATE_PASSWORD,data,formDataConfiguration);
export const updatePassword = (data) => apiWrapper(put,url.UPDATE_PASSWORD,data);

// banner
export const createBanner = (data) => apiWrapper(postForm,url.CREATE_BANNER,data);
export const getBanners = (data) => apiWrapper(get,url.GET_BANNERS,data);
export const getSingleBanner = (id) => apiWrapper(get,url.GET_SINGLE_BANNER + "/" + id);
export const updateBanners = (data, id) => apiWrapper(putForm,url.GET_BANNERS + "/" + id,data);

// Products
export const getAllProducts = (data) => apiWrapper(post, url.GET_ALL_PRODUCTS, data);
export const getCarrefourScrapeListById = (id) => apiWrapper(get, url.GET_CARREFOUR_SCRAPE_LIST_BY_ID + "/" + id);
export const updateProduct = (data, id) => apiWrapper(put, url.UPDATE_PRODUCT + "/" + id, data);
export const searchProductsBySource = (data) => apiWrapper(post, url.GET_ALL_PRODUCTS, data);
export const setProductMatch = (id, matchedProductId) => apiWrapper(patch, url.SET_PRODUCT_MATCH + "/" + id + "/match", { matchedProductId });
export const clearProductMatch = (id) => apiWrapper(patch, url.SET_PRODUCT_MATCH + "/" + id + "/match", { matchedProductId: null });
// Scraper controls
export const getScrapeStatus    = ()     => apiWrapper(get,  url.SCRAPE_STATUS);
export const getScrapeJobs      = (data) => apiWrapper(post, url.SCRAPE_JOBS, data);
export const startAmazonScrape  = ()     => apiWrapper(get,  url.SCRAPE_AMAZON);
export const startCarrefourScrape = ()   => apiWrapper(get,  url.SCRAPE_CARREFOUR);
export const startAllScrape     = ()     => apiWrapper(get,  url.SCRAPE_ALL);
export const stopScraperJob     = ()     => apiWrapper(del,  url.SCRAPE_STOP);
export const runMatcher         = ()     => apiWrapper(get,  url.SCRAPE_MATCH);
export const forceRunMatcher    = ()     => apiWrapper(get,  url.SCRAPE_MATCH + "?force=true");

// Product Links
export const getProductLinks        = (params = {}) => apiWrapper(get,   url.PRODUCT_LINKS, params);
export const addProductLinkAPI      = (data)        => apiWrapper(post,  url.PRODUCT_LINKS, data);
export const updateProductLinkAPI   = (id, data)    => apiWrapper(put,   url.PRODUCT_LINKS + "/" + id, data);
export const toggleProductLinkAPI   = (id)          => apiWrapper(patch, url.PRODUCT_LINKS + "/" + id + "/toggle");
export const deleteProductLinkAPI   = (id)          => apiWrapper(del,   url.PRODUCT_LINKS + "/" + id);

// Users
export const getAllUsers = (data) => apiWrapper(get,url.GET_ALL_USERS,data);
export const getUserCart = (data, id) => apiWrapper(get,url.GET_USER_CART + "/" + id,data);

// Dashboard
export const getDashboardData = (data) => apiWrapper(get,url.GET_DASHBOARD_DATA,data);

// Categories
export const getCategoryData = (data) => apiWrapper(get,url.GET_CATEGORY_DATA,data);
export const getParentCategoryData = (data) => apiWrapper(get,url.GET_PARENT_CATEGORY_DATA,data);
export const getChildCategoryData = (data) => apiWrapper(get,url.GET_CHILD_CATEGORY_DATA,data);
export const updateCategoryData = (data, id) => apiWrapper(putForm,url.UPDATE_CATEGORY_DATA + "/" + id,data);
export const getSingleCategory = (id) => apiWrapper(get,url.GET_CATEGORY_DATA + "/" + id);

